import { Grid } from "@mui/material";
import React from "react";
import {
  FlexCenter,
  FlexColumnSB,
  FlexRowSB,
} from "../../../constant/CustomeStyle";

const items = [
  { status: "Done" },
  { status: "Start" },
  { status: "Done" },
  { status: "In The Process" },
  { status: "Done" },
  { status: "Start" },
  { status: "Done" },
  { status: "In The Process" },
  { status: "Start" },
  { status: "In The Process" },
  { status: "Start" },
  { status: "Done" },
];

const Kitchen = () => {
  return (
    <div style={{ margin: 30 }}>
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="baseline"
      >
        {items.map((item, index) => (
          <KitchenCard item={item} key={index} />
        ))}
      </Grid>
    </div>
  );
};

const KitchenCard = ({ item }) => (
  <FlexCenter
    style={{
      width: 322,
      background: `${
        item.status === "Start"
          ? "#C4C4C4"
          : item.status === "Done"
          ? "#D9E9FF"
          : "#FFFFFF"
      }`,
      borderRadius: 4,
      marginBottom: 20,
    }}
  >
    <FlexColumnSB style={{ height: 135, margin: 10 }}>
      <div
        style={{
          fontSize: 12,
          fontWeight: "500",
          fontFamily: `Poppins, sans-serif`,
          textAlign: "left",
        }}
      >
        <div style={{ color: "#333C4B" }}>Table T6</div>
        <div
          style={{
            color: `${
              item.status === "Start"
                ? "#CA2129"
                : item.status === "Done"
                ? "#0E5A41"
                : "#FF9A3D"
            }`,
          }}
        >
          Waiter: Jon Due
        </div>
      </div>

      <InnerBox item={item} />
    </FlexColumnSB>
  </FlexCenter>
);

const InnerBox = ({ item }) => (
  <div
    style={{
      background: `${
        item.status === "Start"
          ? "#FFF"
          : item.status === "Done"
          ? "#FFF"
          : "#D9E9FF"
      }`,
      width: 282,
      borderRadius: 4,
    }}
  >
    <FlexColumnSB
      style={{
        height: 71.12,
        margin: 8,
      }}
    >
      <FlexRowSB
        style={{
          fontFamily: `Poppins, sans-serif`,
        }}
      >
        <FlexCenter style={{ textAlign: "left", fontSize: 13 }}>
          Chicken Burger "Vegetable"
        </FlexCenter>
        <div style={{ fontSize: 12 }}>
          <div>200g</div>
          <div
            style={{
              color: `${
                item.status === "Start"
                  ? "#CA2129"
                  : item.status === "Done"
                  ? "#0E5A41"
                  : "#FF9A3D"
              }`,
            }}
          >
            18:38
          </div>
        </div>
      </FlexRowSB>

      <FlexCenter>
        <FlexCenter
          style={{
            background: `${
              item.status === "Start"
                ? "#CA2129"
                : item.status === "Done"
                ? "#0E5A41"
                : "#FF9A3D"
            }`,
            width: 266.76,
            height: 30.1,
            borderRadius: 4,
            color: "#FFF",
            fontSize: 14,
            fontWeight: "600",
            fontFamily: `Poppins, sans-serif`,
            cursor: "pointer",
          }}
        >
          {item.status}
        </FlexCenter>
      </FlexCenter>
    </FlexColumnSB>
  </div>
);

export default Kitchen;
